/* ============================================================
   K.NOAH — QUOTE PREVIEW LINK V2

   Creates PNG previews from the current configurator design
   and uploads them to Cloudinary.

   V2:
   - Works with visible canvases
   - Works from GET YOUR QUOTE when canvases are hidden
   - Uses temporary offscreen clone for hidden canvases
   - Does NOT change configurator state
   - Does NOT trigger downloads
   - Does NOT modify kn-export.js

   Cloudinary:
   Cloud Name: lcmwbxcp
   Upload Preset: knoah_quote_designs
   ============================================================ */

(function () {
  'use strict';

  if (window.KNOAH_QUOTE_PREVIEW_LINK_V2) {
    return;
  }

  window.KNOAH_QUOTE_PREVIEW_LINK_V2 = true;


  /* ============================================================
     SETTINGS
     ============================================================ */

  var CLOUD_NAME =
    'lcmwbxcp';

  var UPLOAD_PRESET =
    'knoah_quote_designs';

  var CLOUDINARY_UPLOAD_URL =
    'https://api.cloudinary.com/v1_1/' +
    CLOUD_NAME +
    '/image/upload';


  var HTML_TO_IMAGE_URL =
    'https://cdnjs.cloudflare.com/ajax/libs/html-to-image/1.11.11/html-to-image.min.js';


  var TRANSPARENT_PIXEL =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';


  var FINAL_WIDTH =
    1455;

  var FINAL_HEIGHT =
    2048;

  var FINAL_PADDING =
    45;


  /* ============================================================
     LOAD HTML-TO-IMAGE
     ============================================================ */

  function loadHtmlToImage() {

    return new Promise(function (resolve, reject) {

      if (window.htmlToImage) {

        resolve(
          window.htmlToImage
        );

        return;
      }


      var existing =
        document.querySelector(
          'script[data-kn-html-to-image]'
        );


      if (existing) {

        existing.addEventListener(
          'load',
          function () {

            if (window.htmlToImage) {

              resolve(
                window.htmlToImage
              );

            } else {

              reject(
                new Error(
                  'html-to-image not available.'
                )
              );

            }

          }
        );


        existing.addEventListener(
          'error',
          function () {

            reject(
              new Error(
                'html-to-image could not be loaded.'
              )
            );

          }
        );


        return;
      }


      var script =
        document.createElement(
          'script'
        );


      script.src =
        HTML_TO_IMAGE_URL;

      script.async =
        true;

      script.dataset.knHtmlToImage =
        '1';


      script.onload =
        function () {

          if (window.htmlToImage) {

            resolve(
              window.htmlToImage
            );

          } else {

            reject(
              new Error(
                'html-to-image could not be loaded.'
              )
            );

          }

        };


      script.onerror =
        function () {

          reject(
            new Error(
              'html-to-image could not be loaded.'
            )
          );

        };


      document.head.appendChild(
        script
      );

    });

  }


  /* ============================================================
     NEXT PAINT
     ============================================================ */

  function nextPaint() {

    return new Promise(
      function (resolve) {

        requestAnimationFrame(
          function () {

            requestAnimationFrame(
              resolve
            );

          }
        );

      }
    );

  }


  /* ============================================================
     CANVASES
     ============================================================ */

  function getJerseyCanvas() {

    var root =
      document.getElementById(
        'frx-configurator'
      );


    if (!root) {
      return null;
    }


    return root.querySelector(
      '.frx-canvas'
    );

  }


  function getPantsCanvas() {

    return document.getElementById(
      'kn-pants-canvas'
    );

  }


  /* ============================================================
     IMAGE CHECK
     ============================================================ */

  function imageIsBroken(img) {

    if (!img) {
      return true;
    }


    var src =
      img.getAttribute('src') ||
      img.currentSrc ||
      '';


    if (!src) {
      return true;
    }


    if (
      src ===
      window.location.href
    ) {
      return true;
    }


    if (
      img.complete &&
      img.naturalWidth === 0
    ) {
      return true;
    }


    return false;

  }


  /* ============================================================
     NEUTRALIZE BROKEN OPTIONAL IMAGES
     ============================================================ */

  function neutralizeBrokenImages(root) {

    var states = [];


    if (!root) {

      return function () {};

    }


    root
      .querySelectorAll('img')
      .forEach(
        function (img) {

          if (
            !imageIsBroken(img)
          ) {
            return;
          }


          states.push({

            img: img,

            src:
              img.getAttribute('src'),

            srcset:
              img.getAttribute('srcset'),

            sizes:
              img.getAttribute('sizes')

          });


          img.removeAttribute(
            'srcset'
          );

          img.removeAttribute(
            'sizes'
          );

          img.setAttribute(
            'src',
            TRANSPARENT_PIXEL
          );

        }
      );


    return function restoreImages() {

      states.forEach(
        function (state) {

          if (
            state.src === null
          ) {

            state.img.removeAttribute(
              'src'
            );

          } else {

            state.img.setAttribute(
              'src',
              state.src
            );

          }


          if (
            state.srcset === null
          ) {

            state.img.removeAttribute(
              'srcset'
            );

          } else {

            state.img.setAttribute(
              'srcset',
              state.srcset
            );

          }


          if (
            state.sizes === null
          ) {

            state.img.removeAttribute(
              'sizes'
            );

          } else {

            state.img.setAttribute(
              'sizes',
              state.sizes
            );

          }

        }
      );

    };

  }


  /* ============================================================
     RENDER FILTER
     ============================================================ */

  function exportFilter(node) {

    if (!node) {
      return true;
    }


    /*
      Never include download controls
      inside quote preview.
    */

    if (
      node.classList &&
      node.classList.contains(
        'kn-live-download'
      )
    ) {
      return false;
    }


    if (
      node.tagName &&
      node.tagName.toLowerCase() ===
        'img'
    ) {

      var src =
        node.getAttribute('src') ||
        node.currentSrc ||
        '';


      if (!src) {
        return false;
      }

    }


    return true;

  }


  /* ============================================================
     LOAD GENERATED IMAGE
     ============================================================ */

  function loadRenderedImage(
    dataUrl
  ) {

    return new Promise(
      function (
        resolve,
        reject
      ) {

        var image =
          new Image();


        image.onload =
          function () {

            resolve(
              image
            );

          };


        image.onerror =
          function (error) {

            reject(
              error
            );

          };


        image.src =
          dataUrl;

      }
    );

  }


  /* ============================================================
     PREPARE HIDDEN CANVAS FOR QUOTE EXPORT
     ============================================================ */

  async function prepareCanvasForRender(
    canvas
  ) {

    if (!canvas) {

      throw new Error(
        'K.NOAH QUOTE PREVIEW: Canvas not found.'
      );

    }


    /*
      If the real canvas is visible,
      use it exactly as before.
    */

    var rect =
      canvas.getBoundingClientRect();


    if (
      canvas.offsetWidth > 0 &&
      canvas.offsetHeight > 0 &&
      rect.width > 0 &&
      rect.height > 0
    ) {

      return {

        canvas:
          canvas,

        cleanup:
          function () {}

      };

    }


    /*
      Canvas is hidden because the user
      is currently on GET YOUR QUOTE.

      Clone the complete canvas and place
      it outside the visible viewport.
    */

    var clone =
      canvas.cloneNode(
        true
      );


    var stage =
      document.createElement(
        'div'
      );


    stage.setAttribute(
      'data-kn-quote-render-stage',
      '1'
    );


    stage.style.cssText =
      'position:fixed!important;' +
      'left:-10000px!important;' +
      'top:0!important;' +
      'width:700px!important;' +
      'height:auto!important;' +
      'display:block!important;' +
      'visibility:visible!important;' +
      'opacity:1!important;' +
      'pointer-events:none!important;' +
      'overflow:visible!important;' +
      'z-index:-999999!important;';


    clone.style.setProperty(
      'display',
      'block',
      'important'
    );

    clone.style.setProperty(
      'visibility',
      'visible',
      'important'
    );

    clone.style.setProperty(
      'opacity',
      '1',
      'important'
    );

    clone.style.setProperty(
      'position',
      'relative',
      'important'
    );

    clone.style.setProperty(
      'left',
      '0',
      'important'
    );

    clone.style.setProperty(
      'right',
      'auto',
      'important'
    );

    clone.style.setProperty(
      'top',
      '0',
      'important'
    );

    clone.style.setProperty(
      'bottom',
      'auto',
      'important'
    );

    clone.style.setProperty(
      'transform',
      'none',
      'important'
    );

    clone.style.setProperty(
      'transform-origin',
      'top left',
      'important'
    );

    clone.style.setProperty(
      'margin',
      '0',
      'important'
    );

    clone.style.setProperty(
      'padding',
      '0',
      'important'
    );

    clone.style.setProperty(
      'overflow',
      'visible',
      'important'
    );


    /*
      Fallback dimensions.

      Visible Jersey test:
      167 × 235

      We preserve this ratio while using
      a larger offscreen source.
    */

    var width =
      700;

    var height =
      Math.round(
        width *
        (
          235 /
          167
        )
      );


    clone.style.setProperty(
      'width',
      width + 'px',
      'important'
    );

    clone.style.setProperty(
      'height',
      height + 'px',
      'important'
    );

    clone.style.setProperty(
      'max-width',
      'none',
      'important'
    );

    clone.style.setProperty(
      'max-height',
      'none',
      'important'
    );

    clone.style.setProperty(
      'min-width',
      '0',
      'important'
    );

    clone.style.setProperty(
      'min-height',
      '0',
      'important'
    );


    stage.appendChild(
      clone
    );


    document.body.appendChild(
      stage
    );


    await nextPaint();


    return {

      canvas:
        clone,

      cleanup:
        function () {

          if (
            stage &&
            stage.parentNode
          ) {

            stage.parentNode.removeChild(
              stage
            );

          }

        }

    };

  }


  /* ============================================================
     RENDER CANVAS
     ============================================================ */

  async function renderCanvas(
    canvas
  ) {

    if (!canvas) {

      throw new Error(
        'K.NOAH QUOTE PREVIEW: Canvas not found.'
      );

    }


    var restoreImages =
      null;

    var prepared =
      null;


    try {

      var htmlToImage =
        await loadHtmlToImage();


      /*
        Prepare visible OR hidden canvas.
      */

      prepared =
        await prepareCanvasForRender(
          canvas
        );


      var renderTarget =
        prepared.canvas;


      await nextPaint();


      /* --------------------------------------------------------
         REAL SOURCE SIZE
         -------------------------------------------------------- */

      var sourceWidth =
        renderTarget.offsetWidth;


      var sourceHeight =
        renderTarget.offsetHeight;


      if (
        !sourceWidth ||
        !sourceHeight
      ) {

        var rect =
          renderTarget.getBoundingClientRect();


        sourceWidth =
          Math.round(
            rect.width
          );


        sourceHeight =
          Math.round(
            rect.height
          );

      }


      if (
        !sourceWidth ||
        !sourceHeight
      ) {

        throw new Error(
          'Could not determine canvas size.'
        );

      }


      console.log(
        'K.NOAH QUOTE PREVIEW — source size:',
        sourceWidth +
        ' × ' +
        sourceHeight
      );


      /* --------------------------------------------------------
         OPTIONAL IMAGES
         -------------------------------------------------------- */

      restoreImages =
        neutralizeBrokenImages(
          renderTarget
        );


      await nextPaint();


      /* --------------------------------------------------------
         RENDER CURRENT DESIGN
         -------------------------------------------------------- */

      var renderedDataUrl =
        await htmlToImage.toPng(
          renderTarget,
          {

            width:
              sourceWidth,

            height:
              sourceHeight,

            canvasWidth:
              sourceWidth * 2,

            canvasHeight:
              sourceHeight * 2,

            pixelRatio:
              2,

            backgroundColor:
              '#e9e9e7',

            cacheBust:
              false,

            includeQueryParams:
              true,

            imagePlaceholder:
              TRANSPARENT_PIXEL,

            skipAutoScale:
              true,

            filter:
              exportFilter,

            style: {

              position:
                'relative',

              left:
                '0',

              right:
                'auto',

              top:
                '0',

              bottom:
                'auto',

              width:
                sourceWidth + 'px',

              height:
                sourceHeight + 'px',

              maxWidth:
                'none',

              maxHeight:
                'none',

              minWidth:
                '0',

              minHeight:
                '0',

              margin:
                '0',

              padding:
                '0',

              transform:
                'none',

              transformOrigin:
                'top left',

              overflow:
                'visible'

            }

          }
        );


      var renderedImage =
        await loadRenderedImage(
          renderedDataUrl
        );


      /* --------------------------------------------------------
         FINAL 1455 × 2048 CANVAS
         -------------------------------------------------------- */

      var output =
        document.createElement(
          'canvas'
        );


      output.width =
        FINAL_WIDTH;

      output.height =
        FINAL_HEIGHT;


      var ctx =
        output.getContext(
          '2d'
        );


      if (!ctx) {

        throw new Error(
          'Could not create final canvas.'
        );

      }


      ctx.fillStyle =
        '#e9e9e7';


      ctx.fillRect(
        0,
        0,
        FINAL_WIDTH,
        FINAL_HEIGHT
      );


      var availableWidth =
        FINAL_WIDTH -
        (
          FINAL_PADDING *
          2
        );


      var availableHeight =
        FINAL_HEIGHT -
        (
          FINAL_PADDING *
          2
        );


      var scale =
        Math.min(

          availableWidth /
          renderedImage.width,

          availableHeight /
          renderedImage.height

        );


      var drawWidth =
        renderedImage.width *
        scale;


      var drawHeight =
        renderedImage.height *
        scale;


      var drawX =
        (
          FINAL_WIDTH -
          drawWidth
        ) / 2;


      var drawY =
        (
          FINAL_HEIGHT -
          drawHeight
        ) / 2;


      ctx.imageSmoothingEnabled =
        true;

      ctx.imageSmoothingQuality =
        'high';


      ctx.drawImage(

        renderedImage,

        drawX,
        drawY,

        drawWidth,
        drawHeight

      );


      return output.toDataURL(
        'image/png',
        1
      );


    } finally {

      if (
        restoreImages
      ) {

        restoreImages();

      }


      if (
        prepared &&
        typeof prepared.cleanup ===
          'function'
      ) {

        prepared.cleanup();

      }

    }

  }


  /* ============================================================
     DATA URL → BLOB
     ============================================================ */

  function dataUrlToBlob(
    dataUrl
  ) {

    var parts =
      dataUrl.split(',');


    var mimeMatch =
      parts[0].match(
        /data:([^;]+)/
      );


    var mime =
      mimeMatch
        ? mimeMatch[1]
        : 'image/png';


    var binary =
      atob(
        parts[1]
      );


    var bytes =
      new Uint8Array(
        binary.length
      );


    for (
      var i = 0;
      i < binary.length;
      i++
    ) {

      bytes[i] =
        binary.charCodeAt(i);

    }


    return new Blob(
      [bytes],
      {
        type:
          mime
      }
    );

  }


  /* ============================================================
     CLOUDINARY UPLOAD
     ============================================================ */

  async function uploadToCloudinary(
    dataUrl,
    type
  ) {

    var blob =
      dataUrlToBlob(
        dataUrl
      );


    var formData =
      new FormData();


    formData.append(
      'file',
      blob,
      'KNOAH-' +
      String(
        type ||
        'DESIGN'
      ).toUpperCase() +
      '.png'
    );


    formData.append(
      'upload_preset',
      UPLOAD_PRESET
    );


    var response =
      await fetch(
        CLOUDINARY_UPLOAD_URL,
        {

          method:
            'POST',

          body:
            formData

        }
      );


    var result =
      await response.json();


    if (
      !response.ok ||
      !result ||
      !result.secure_url
    ) {

      console.error(
        'K.NOAH CLOUDINARY:',
        result
      );


      throw new Error(
        result &&
        result.error &&
        result.error.message
          ? result.error.message
          : 'Cloudinary upload failed.'
      );

    }


    console.log(
      'K.NOAH CLOUDINARY — uploaded:',
      result.secure_url
    );


    return result.secure_url;

  }


  /* ============================================================
     CREATE JERSEY PREVIEW
     ============================================================ */

  async function createJerseyPreview() {

    console.log(
      'K.NOAH QUOTE PREVIEW — creating Jersey...'
    );


    var image =
      await renderCanvas(
        getJerseyCanvas()
      );


    var url =
      await uploadToCloudinary(
        image,
        'JERSEY'
      );


    return {

      type:
        'jersey',

      url:
        url

    };

  }


  /* ============================================================
     CREATE PANTS PREVIEW
     ============================================================ */

  async function createPantsPreview() {

    console.log(
      'K.NOAH QUOTE PREVIEW — creating Pants...'
    );


    var image =
      await renderCanvas(
        getPantsCanvas()
      );


    var url =
      await uploadToCloudinary(
        image,
        'PANTS'
      );


    return {

      type:
        'pants',

      url:
        url

    };

  }


  /* ============================================================
     PUBLIC API
     ============================================================ */

  window.KNoahQuotePreview = {

    createJersey:
      createJerseyPreview,

    createPants:
      createPantsPreview,

    renderJersey:
      function () {

        return renderCanvas(
          getJerseyCanvas()
        );

      },

    renderPants:
      function () {

        return renderCanvas(
          getPantsCanvas()
        );

      },

    upload:
      uploadToCloudinary

  };


  console.log(
    'K.NOAH Quote Preview Link V2 loaded.'
  );

})();